import { mix } from "@chorda/core";
import { Delete } from "./Delete";
export const Notification = (props) => {
    return mix({
        css: 'notification',
        templates: {
            delete: Delete
        }
    }, props && {
        css: props.css,
        text: props.text,
        components: {
            delete: props.delete == null ? true : props.delete
        }
    });
};
